import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Footer from "../../assets/images/Footer.png";

const REDIRECT_DELAY_SECONDS = 4;

const AggregatorResult = ({ variant }) => {
  const { id } = useParams();
  const location = useLocation();
  const result = location.state?.result;
  const [countdown, setCountdown] = useState(REDIRECT_DELAY_SECONDS);

  const isSuccess = variant === "success";
  const returnUrl = result?.returnUrl;

  useEffect(() => {
    if (!returnUrl) return;

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.location.href = returnUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [returnUrl]);

  const detailRows = [
    { label: "Order ID", value: result?.orderId },
    { label: "Status", value: result?.status },
    { label: "Response Code", value: result?.respCode },
    { label: "Scheme", value: result?.scheme },
    { label: "Simulated", value: result?.simulated },
    { label: "Approval Code", value: result?.approvalCode },
  ].filter((row) => row.value != null && row.value !== "");

  return (
    <div className="md:w-[562px] w-[300px] mx-auto mt-40 overflow-hidden font-LT px-2">
      <div className="flex flex-col items-center mt-10">
        <div
          className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
            isSuccess ? "bg-emerald-50" : "bg-rose-50"
          }`}
        >
          {isSuccess ? (
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
                fill="#059669"
              />
            </svg>
          ) : (
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="#DC2626"
              />
            </svg>
          )}
        </div>

        <h1
          className={`text-2xl font-bold mb-2 ${
            isSuccess ? "text-green-600" : "text-red-600"
          }`}
        >
          {isSuccess ? "Payment Successful!" : "Payment Failed!"}
        </h1>

        <p className="text-[18.75px] text-darkGrey text-center font-normal md:w-[419px]">
          {isSuccess
            ? `Your transaction${id ? ` (${id})` : ""} has been completed successfully.`
            : `Your transaction${id ? ` (${id})` : ""} could not be completed.`}
        </p>

        {result && detailRows.length > 0 && (
          <div className="w-full md:w-[398px] mt-8 p-4 rounded-xl border border-slate-200 bg-slate-50/50">
            {detailRows.map((row) => (
              <div
                key={row.label}
                className="flex justify-between gap-4 py-2 border-b border-slate-100 last:border-b-0 text-sm"
              >
                <span className="text-slate-500">{row.label}</span>
                <span className="font-semibold text-slate-800 text-right">
                  {row.value}
                </span>
              </div>
            ))}
          </div>
        )}

        {returnUrl && (
          <p className="text-center text-sm text-primary mt-8 animate-pulse">
            Redirecting to merchant in {countdown} second
            {countdown === 1 ? "" : "s"}...
          </p>
        )}

        {returnUrl && (
          <button
            type="button"
            onClick={() => {
              window.location.href = returnUrl;
            }}
            className="rounded-[10px] w-full md:w-[307px] h-[61.38px] mt-6 bg-primary text-white font-bold transition-all hover:bg-opacity-90"
          >
            Return to Merchant
          </button>
        )}

        <div className="flex justify-center mt-10 mb-2">
          <img src={Footer} alt="footerLogo" className="w-[227px]" />
        </div>
      </div>
    </div>
  );
};

export default AggregatorResult;
